import React, { useState } from 'react'
import Header from 'portal/layouts/BasicLayout/Header/Header'
import Footer from 'portal/layouts/BasicLayout/Footer/Footer'
import ResearchCenter from './ResearchCenter'
import DataService from './DataService'
import TalentTraining from './TalentTraining'
import CompleteFlow from './CompleteFlow'
import QualityControl from './QualityControl'
import Technology from './Technology'
import { WheelEvent } from 'react/index'

export default function Home() {
  const [visible, setVisible] = useState(true)
  function handleScroll(e:WheelEvent<HTMLDivElement>) {
    if (e.deltaY) {
      if(e.deltaY > 0) {
        setVisible(false)
      }
      if(e.deltaY < 0) {
        setVisible(true)
      }
    }
  }
  function showHeader() {
    if(visible) {
      return (
        <Header />
      )
    }
    return (<></>)
  }
  return (
    <React.Fragment>
      {showHeader()}
      <div onWheel={handleScroll}>
        <ResearchCenter />
        <DataService />
        <TalentTraining />
        <CompleteFlow />
        <QualityControl />
        <Technology />
        <Footer />
      </div>
    </React.Fragment>
  )
}
